module.exports = require('./helpers/bundle-url').getBundleURL('bhHUx') + "sad_kilroy.586cd437.png";